import { ContainerWrapper } from '../Container'
import SectionHeading from './SectionHeading'
import SectionSubText from './SectionSubText'
import BookACallButton from '../Buttons/Specials/BookACallButton'
import { isMobile } from 'react-device-detect'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

const BETTER_DIRECT_MAIL_MODAL_PROPS = {
    formName: 'Better Direct Mail Strategy Call',
}

const CallIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            fill="#FFF8E9"
            className="w-[44px] h-auto">
            <path d="M224.2 89C216.3 70.1 195.7 60.1 176.1 65.4L170.6 66.9C106 84.5 50.8 147.1 66.9 223.3C104 398.3 241.7 536 416.7 573.1C493 589.3 555.5 534 573.1 469.4L574.6 463.9C580 444.2 569.9 423.6 551.1 415.8L453.8 375.3C437.3 368.4 418.2 373.2 406.8 387.1L368.2 434.3C297.9 399.4 241.3 341 208.8 269.3L253 233.3C266.9 222 271.6 202.9 264.8 186.3L224.2 89z" />
        </svg>
    )
}

const RibbonIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            fill="#FFF8E9"
            className="w-[50px] h-auto">
            <path d="M363.1 64C396.5 64 427.6 81.4 445 109.9C446.2 111.9 458 131.2 480.3 167.7C501.4 202.2 498.6 246.2 473.3 277.7L406.3 361.7L492.5 470C498 476.9 496.9 486.9 490 492.5L410 556.5C403.1 562 393 560.9 387.5 554L166.6 277.8C141.3 246.3 138.5 202.3 159.6 167.8C182 131.2 193.7 111.9 195 109.9C212.4 81.4 243.4 64 276.9 64L363.2 64zM320 253.2L368.6 192L271.3 192L319.9 253.2zM203 400.2L289.2 508L252.4 554C246.9 560.9 236.8 562 229.9 556.5L149.9 492.5C143 487 141.9 476.9 147.4 470L203 400.2z" />
        </svg>
    )
}

const SyncIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            fill="#FFF8E9"
            className="w-[50px] h-auto">
            <path d="M129.9 292.5C143.2 199.5 223.3 128 320 128C373 128 421 149.5 455.8 184.2C456 184.4 456.2 184.6 456.4 184.8L464 192L416.1 192C398.4 192 384.1 206.3 384.1 224C384.1 241.7 398.4 256 416.1 256L544.1 256C561.8 256 576.1 241.7 576.1 224L576.1 96C576.1 78.3 561.8 64 544.1 64C526.4 64 512.1 78.3 512.1 96L512.1 149.4L500.8 138.7C454.5 92.6 390.5 64 320 64C191 64 84.3 159.4 66.6 283.5C64.1 301 76.2 317.2 93.7 319.7C111.2 322.2 127.4 310 129.9 292.6zM573.4 356.5C575.9 339 563.7 322.8 546.3 320.3C528.9 317.8 512.6 330 510.1 347.4C496.8 440.4 416.7 511.9 320 511.9C267 511.9 219 490.4 184.2 455.7C184 455.5 183.8 455.3 183.6 455.1L176 447.9L223.9 447.9C241.6 447.9 255.9 433.6 255.9 415.9C255.9 398.2 241.6 383.9 223.9 383.9L96 384C87.5 384 79.3 387.4 73.3 393.5C67.3 399.6 63.9 407.7 64 416.3L65 543.3C65.1 561 79.6 575.2 97.3 575C115 574.8 129.2 560.4 129 542.7L128.6 491.2L139.3 501.3C185.6 547.4 249.5 576 320 576C449 576 555.7 480.6 573.4 356.5z" />
        </svg>
    )
}
const RocketIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            fill="#FFF8E9"
            className="w-[35px] h-auto">
            <path d="M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2l0 82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-107.2c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
        </svg>
    )
}
const ScaleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
            fill="#FFF8E9"
            className="w-[43px] h-auto">
            <path d="M384 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L398.4 96c-5.2 25.8-22.9 47.1-46.4 57.3L352 448l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-23.5-10.3-41.2-31.6-46.4-57.3L128 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288l144.9 0L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320l144.9 0L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z" />
        </svg>
    )
}

const steps = [
    {
        number: 1,
        title: 'Book a Call',
        description:
            'talk with a marketing coach about your current campaigns.',
        Icon: CallIcon,
    },
    {
        number: 2,
        title: 'Pick Your Designs',
        description:
            'choose from high-converting templates (or upload your own).',
        Icon: RibbonIcon,
    },
    {
        number: 3,
        title: 'Upload or Build Lists',
        description: 'refine your own list or access our high-quality lists.',
        Icon: SyncIcon,
    },
    {
        number: 4,
        title: 'Launch Your Campaign',
        description: 'we print, stamp, and mail within 3 days.',
        Icon: RocketIcon,
    },
    {
        number: 5,
        title: 'Track & Scale',
        description: 'monitor responses, refine, and repeat with our support.',
        Icon: ScaleIcon,
    },
]

function StepContent({ title, description }) {
    return (
        <>
            <h3 className="md:mt-6 text-xl font-semibold text-olm-black max-w-sm md:max-w-full">
                {title}
            </h3>
            <p className="mt-2 text-olm-new-black max-w-sm leading-relaxed md:max-w-full">
                {description}
            </p>
        </>
    )
}
function Step({ title, description, Icon }) {
    return (
        <div className="flex flex-row md:flex-col md:items-center text-center w-full flex-wrap gap-4 md:gap-0">
            <div className="relative z-10">
                <div className="w-[60px] h-[60px] md:w-[60px] md:h-[60px] rounded-full bg-[#f05a2b] flex items-center justify-center shadow-[0_10px_24px_rgba(255,101,47,0.18)]">
                    <Icon />
                </div>
            </div>
            {isMobile ? (
                <div className="w-3/4">
                    <StepContent title={title} description={description} />
                </div>
            ) : (
                <StepContent title={title} description={description} />
            )}
        </div>
    )
}

export default function CallMailboxProcess({
    subHeading = 'No downtime, no guesswork. Just better results, faster. Making the move is simple and fast:',
}) {
    return (
        <section
            aria-labelledby="how-it-works-heading"
            className="py-5"
            style={{ marginTop: '0px' }}>
            <ContainerWrapper>
                <SectionHeading>
                    From Free Coaching Call to{' '}
                    <br className="hidden lg:block" /> Mailbox Results
                </SectionHeading>
                <SectionSubText>{subHeading}</SectionSubText>
                {/* Steps with connectors on md+ */}
                <div className="w-full max-w-6xl px-2 py-5 mt-8 mx-auto">
                    <div className="flex flex-col md:flex-row items-start md:justify-center gap-6 md:gap-6">
                        {steps.map((s, idx) => (
                            <div
                                key={s.number}
                                className={`flex items-center w-full md:w-1/${steps.length} relative`}>
                                <Step {...s} />
                                {/* connector line except after the last item (md+) */}
                                {idx < steps.length - 1 && (
                                    // <div className="hidden md:block h-[2px] bg-[#ED5C2F] w-16 md:w-full mx-4 shrink-0 absolute left-1/2 top-[30px]" />
                                    <div className="h-full w-[2px] top-[calc(50%-20px)] left-[15px] md:h-[2px] bg-[#ED5C2F] md:w-full mx-4 shrink-0 absolute md:left-1/2 md:top-[30px] z-1" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* CTAs */}
                <div className="mt-12 md:mt-16 flex flex-col sm:flex-row items-center justify-center gap-4 max-w-3xl mx-auto">
                    <div className="max-w-[220px] w-full">
                        <BookACallButton
                            Modal={HomepageBookCallLeadModal}
                            modalProps={BETTER_DIRECT_MAIL_MODAL_PROPS}>
                            Book A Call Now
                        </BookACallButton>
                    </div>
                </div>
            </ContainerWrapper>
        </section>
    )
}
